module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-tempe-in-tempe-arizona-edc3cf94ecce729ba1dea9780742ba75.png";